export * as c from "./c";
export { forAll } from "./forAll";
